import {Component, OnInit} from '@angular/core';
import {ChartDataSet, ChartOptions} from '../../../../../shared/components/chart/chart.component';
import {ChartsVccService} from '../../../../service/charts-vcc.service';
import moment from 'moment';
import {VccChartFilter} from '../../../../model/funding-vcc-chart-filter';
import {ChartResponse, CirculationChartModel} from '../../../../model/vcc-chart-model';
import {Merchant} from '../../../../model/merchant-guid';
import {MerchantsService} from 'src/infrastructure/merchants/service/merchants.service';
import {AdxVccFilter} from 'src/app/finance-resource/model/adx-data';
import {AdxVccService} from 'src/app/finance-resource/service/adx-vcc.service';
import {Router} from '@angular/router';
import {catchError, finalize} from 'rxjs/operators';
import {of} from 'rxjs';

@Component({
    selector: 'circulation-vcc-chart',
    templateUrl: './circulation-vcc-chart.component.html',
    standalone: false
})

export class CirculationVccChartComponent implements OnInit {

    public shortLabels: string[] = [];
    merchantGuids: Merchant[] = [];
    public dataCirculation!: ChartDataSet;
    public vccChartFilter: VccChartFilter = {} as VccChartFilter;
    adxFilter: AdxVccFilter = {};
    public isLoading = false;
    public isError = false;
    public circulationVccChartOptions: ChartOptions = {
      responsive: true,
      plugins: {
          legend: {
            display: true,
            align: 'center'
          },
          datalabels: {
            display: 'auto',
            anchor: 'end',
            align: 'end',
            font: {
              weight: 'bold'
            },
            formatter: function(value) {
              if(value === 0 ){
                value = '';
                return value;
              }
            }
          }
      }
    }

    constructor(private chartsVccService: ChartsVccService,
      private merchantsService: MerchantsService,
      private adxService: AdxVccService,
      private router: Router
    ) { }

    ngOnInit() {
      const today = moment();
      this.chartsVccService.getLatestDate().subscribe((latestReleasedDate) => {
        this.vccChartFilter.propertyName = 'releasedDateFrom';
        this.vccChartFilter.orderKey = 'DESC';
        this.vccChartFilter.releasedDateFrom = latestReleasedDate;
        this.vccChartFilter.releasedDateTo = today.format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');

        this.chartsVccService.getVccChartFilter().subscribe((filter) => {
          this.vccChartFilter.merchantGuid = filter.merchantGuid;
          this.vccChartFilter.releasedDateFrom = filter.releasedDateFrom ? moment(filter.releasedDateFrom).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : this.vccChartFilter.releasedDateFrom;
          this.vccChartFilter.releasedDateTo = filter.releasedDateTo ? moment(filter.releasedDateTo).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : this.vccChartFilter.releasedDateTo;

          this.merchantsService.merchants$.subscribe((data)=>{
            this.merchantGuids = data;
            this.getCirculationData();
          });
        });
      });
    }

    get dateFilterText() {
      return this.chartsVccService.getDateSubTitle();
    }

    getCirculationData() {
      this.isLoading = true;
      this.isError = false;

      this.chartsVccService.searchCirculationVcc(this.vccChartFilter)
        .pipe(
          finalize(() => {
            this.isLoading = false;
          }),
          catchError(error => {
            console.error('Error getting circulation data:', error);
            this.isError = true;
            return of([]);
          })
        )
        .subscribe((circulationResponse: CirculationChartModel[]) => {
          if (circulationResponse && circulationResponse.length > 0) {
            this.buildCirculationDataSet(circulationResponse);
          } else {
            this.isError = true;
          }
        });
    }

    buildCirculationDataSet(circulationData: CirculationChartModel[]) {
      this.shortLabels = circulationData.map(item => {
        const merchant = this.merchantGuids.find(m => m.merchantGuid === item.merchantGuid);
        return merchant ? merchant.shortName : '';
      });

      const activated = circulationData.map((item) => item.activated);
      const outDated = circulationData.map((item) => item.outDated);

      this.dataCirculation = {
        labels: this.shortLabels,
        datasets: [{
            data: activated,
            label: 'Activated',
            backgroundColor: '#0289C7'
          },
          {
            data: outDated,
            label: 'Outdated Cards',
            backgroundColor: '#00593F'
          }
        ]
      };
    }
    navigateToIssueVccPage(event: ChartResponse) {
        const selectedMerchant = this.merchantGuids.find(merchant => merchant.shortName === event.label);
        this.adxFilter.merchantGuid = selectedMerchant?.merchantGuid;
        this.adxFilter.dateCreatedFrom = this.vccChartFilter.releasedDateFrom ? moment(this.vccChartFilter.releasedDateFrom).toDate() : null;
        this.adxFilter.dateCreatedTo = this.vccChartFilter.releasedDateTo ? moment(this.vccChartFilter.releasedDateTo).toDate() : null;
        this.adxFilter.cardStatus = event.datasetIndex > 0 ? 'Outdated' : 'Card - Active';
        this.adxService.setAdxFilter(this.adxFilter);
        this.router.navigate(['/FinanceResources/AdxVcc']);
      }
}
